import { render, staticRenderFns } from "./EmergencyGoodsManage.vue?vue&type=template&id=68205f00&scoped=true&"
import script from "./EmergencyGoodsManage.vue?vue&type=script&lang=js&"
export * from "./EmergencyGoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyGoodsManage.vue?vue&type=style&index=0&id=68205f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68205f00",
  null
  
)

export default component.exports